import { createAction, createReducer, createSelector } from '@reduxjs/toolkit'
import { CcamCode } from '../../core/models/CcamCode'
import { retrieveCcamCodes } from '../../core/use-cases/retrieveCcamCodes'
import { AppState } from '../store'

type CcamCodesState = {
  loading: boolean
  value: CcamCode[]
}

export const resetCcamCodes = createAction('ccamCodes/reset')

const initialState: CcamCodesState = {
  loading: false,
  value: [],
}

export const ccamCodesReducer = createReducer(initialState, builder => {
  builder.addCase(retrieveCcamCodes.pending, state => {
    state.loading = true
    state.value = []
  })
  builder.addCase(retrieveCcamCodes.fulfilled, (state, action) => {
    state.loading = false
    state.value = action.payload
  })
  builder.addCase(resetCcamCodes, state => {
    state.value = []
  })
})

export const selectCcamCodes = (state: AppState) => state.ccamCodes.value
export const selectCcamCodeById = (id: string) =>
  createSelector(selectCcamCodes, state =>
    state.find(ccamCode => ccamCode.id === id)
  )
